var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "6" } },
        [
          _c("app-color-picker", {
            attrs: {
              color: _vm.value.Style.BackgroundColor,
              label: _vm.$ct("backgroundColor"),
              fancy: "",
            },
            on: {
              input: function ($event) {
                _vm.value.Style.BackgroundColor = $event
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "6" } },
        [
          _c("app-color-picker", {
            attrs: {
              color: _vm.value.Style.Color,
              label: _vm.$ct("textColor"),
              fancy: "",
            },
            on: {
              input: function ($event) {
                _vm.value.Style.Color = $event
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { md: "3", xs: "12" } },
        [
          _c("w-checkbox", {
            attrs: { label: _vm.$ct("bold") },
            model: {
              value: _vm.value.Style.Bold,
              callback: function ($$v) {
                _vm.$set(_vm.value.Style, "Bold", $$v)
              },
              expression: "value.Style.Bold",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { md: "3", xs: "12" } },
        [
          _c("w-checkbox", {
            attrs: { label: _vm.$ct("italic") },
            model: {
              value: _vm.value.Style.Italic,
              callback: function ($$v) {
                _vm.$set(_vm.value.Style, "Italic", $$v)
              },
              expression: "value.Style.Italic",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { md: "3", xs: "12" } },
        [
          _c("w-checkbox", {
            attrs: { label: _vm.$ct("underline") },
            model: {
              value: _vm.value.Style.Underline,
              callback: function ($$v) {
                _vm.$set(_vm.value.Style, "Underline", $$v)
              },
              expression: "value.Style.Underline",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }